import { render, staticRenderFns } from "./GutenbergHome.vue?vue&type=template&id=2689f2c0&scoped=true&"
import script from "./GutenbergHome.vue?vue&type=script&lang=js&"
export * from "./GutenbergHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2689f2c0",
  null
  
)

export default component.exports